import { ChangeEvent, memo } from 'react';
import {
  Divider,
  DialogContent,
  DialogContentText,
  Box,
  Typography,
  TextField,
} from '@mui/material';

import { useTranslation } from 'react-i18next';
import { UploadImage } from '../../../../../components/common/avatars/UploadImage';
import { Loader } from '../../../../../components/Loader';
import { ErrorsStack } from '../../../../../components/ErrorsStack';
import STRING_KEYS from '../../../../../language/keys';
import { style } from './style';

type ManualContentProps = {
  isLoading:boolean,
  isError:boolean,
  errorMessage: string,
  isUploadingImage: boolean,
  onUploadImage: (e: React.ChangeEvent<HTMLInputElement>) => void,
  educationImage: string,
  isFieldError: boolean,
  educationName: string,
  onChangeEducationName: (enteredEducationName: string) => void,
}

const ContentModal = ({
  isLoading,
  isError,
  errorMessage,
  isUploadingImage,
  onUploadImage,
  educationImage,
  isFieldError,
  educationName,
  onChangeEducationName,
}: ManualContentProps):JSX.Element => {
  const { t: translate } = useTranslation();
  const defineContent = () => {
    if (isLoading) {
      return <Loader top="45%" left="45%" />;
    }

    return (
      <>
        {isError && (
          <div style={ style.errorWrapper }>
            <ErrorsStack
              errors={ [] }
              errorMessage={ errorMessage }
            />
          </div>
        )}
        <DialogContentText style={ style.contentWraper }>
          <Box style={ style.box }>
            <UploadImage
              isDisabled={ false }
              isLoading={ isUploadingImage }
              handleInputUploadImage={ onUploadImage }
              alt="alt"
              profileImage={ educationImage }
            />
            <Typography style={ style.typography }>
              {translate(STRING_KEYS.EDUCATION_INSTITUTE_LOGO)}
            </Typography>
          </Box>
          <Divider style={ style.divider } />
          <TextField
            fullWidth
            name={ translate(STRING_KEYS.EDUCATION_INSTITUTE_NAME) }
            label={ translate(STRING_KEYS.EDUCATION_INSTITUTE_NAME) }
            error={ isFieldError }
            value={ educationName }
            helperText={ isFieldError ? translate(STRING_KEYS.EDUCATION_NAME_VALIDATION) : '' }
            onChange={ (event: ChangeEvent<HTMLInputElement>) => {
              onChangeEducationName(event.target.value);
            } }
          />
        </DialogContentText>
      </>
    );
  };

  return (
    <DialogContent style={ style.dialogContent }>
      { defineContent() }
    </DialogContent>
  );
};

export default memo(ContentModal);
